'use strict';

angular.module('integrationModule')

.factory('Integration', function (DS)
{
    return DS.defineResource({
        basePath: '/api/',
        name: 'Integration',
        endpoint: 'integrations',
        upsert: true
    });
});
